import { mapGetters } from 'vuex'
import { mapState } from 'vuex'
import { states } from '../js/states'
export default {
    data() {
        return {
            states: states
        }
    },

    computed: {
        inCP() {
            return window.inCP;
        },
        ...mapState(['isPortal']),
        ...mapState('bondscanner',[
            'urlFilters'
        ]),

        subFilters() {
            return this.urlFilters && this.urlFilters.filters;
        }
    },
    methods: {
        getFilterValue(code) {
            if (this.subFilters && this.subFilters.find(f=> f.code === code)) {
                return this.subFilters.find(f => f.code === code).value;
            }
            return '';
        }
    }
}